module.exports = __webpack_public_path__ + "register/img/loading_anim_transparent.2f68bfe7.gif";